<div class="modal-container">
    <div class="modal-header">
        <button type="button" class="close pull-right w-auto" aria-label="Close" (click)="cancelButton()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="mb-4 text-center">
            <img class="icon-exclamation" src="assets/icons/icon-exclamation.svg" alt="Exclamation Icon" />
            <small class="are-you-sure">{{ areYouSureText }}</small>
        </div>
        <div class="item-title" [innerHTML]="itemTitle"></div>
    </div>
    <div class="modal-footer">
        <div class="d-flex buttons">
            <button class="btn btn-secondary" (click)="confirmButton()">ยืนยัน</button>
            <button class="btn btn-secondary" (click)="cancelButton()">ยกเลิก</button>
        </div>
    </div>
</div>
